import React from 'react';
import { useAuth } from '../../context/AuthContext';

const Header = ({ title }) => {
  const { user } = useAuth();
  const isExecutive = user?.role === 'Secretary' || user?.role === 'Director';

  if (isExecutive) {
    return (
      <div className="bg-slate-900 border-b border-slate-800 px-6 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold text-white">{title}</h1>
        <div className="flex items-center gap-3">
          <div className="text-right">
            <div className="text-sm font-medium text-slate-200">{user?.fullName}</div>
            <div className="text-xs text-slate-400">{user?.role}</div>
          </div>
          <div className="w-9 h-9 bg-blue-700 rounded-full flex items-center justify-center text-white font-bold text-sm">
            {user?.fullName?.charAt(0)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
      <h1 className="text-xl font-bold text-gray-800">{title}</h1>
      <div className="flex items-center gap-3">
        <div className="text-right">
          <div className="text-sm font-medium text-gray-700">{user?.fullName}</div>
          <div className="text-xs text-gray-500">{user?.role}</div>
        </div>
        <div className="w-9 h-9 bg-blue-800 rounded-full flex items-center justify-center text-white font-bold text-sm">
          {user?.fullName?.charAt(0)}
        </div>
      </div>
    </div>
  );
};

export default Header;
